import { Component, Directive, Output, EventEmitter, ElementRef, Input, HostListener } from '@angular/core';

@Component({
  selector: 'va-nested-selector',
  template: `
    <div class="va-nested-selector" (hideEvent)="hide()" hide-selector>
      <div class="va-nested-selector-button" (click)="change()">
        <div class="va-nested-selector-title">
          <ng-content select="va-nested-selector-title"></ng-content>
        </div>
        <div class="va-nested-selector-arrow">&#x25BE;</div>
      </div>
      <div
        *ngIf="showSelector"
        class="va-nested-selector-selector"
        [ngClass]="{ 'va-nested-selector-max-height': !!maxHeight }"
        [ngStyle]="{ 'max-height': maxHeight + 'px' }"
      >
        <ng-content select="va-selector-nest"></ng-content>
      </div>
    </div>
  `,
  styles: [
    `
      .va-nested-selector {
        position: relative;
      }
    `,
    `
      .va-nested-selector-selector {
        background: #fff;
        border-radius: 2px;
        display: inline-block;
        position: absolute;
        width: 300px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        z-index: 10;
      }
    `,
    `
      .va-nested-selector-button {
        width: 200px;
        border-radius: 2px;
        background: #fff;
        color: #1880bf;
        border: 1px solid;
        cursor: pointer;
        padding: 5px;
        display: flex;
      }
    `,
    `
      .va-nested-selector-title {
        flex-grow: 1;
      }
    `,
    `
      .va-nested-selector-arrow {
        width: 15px;
      }
    `,
    `
      .va-nested-selector-max-height {
        overflow-y: auto;
      }
    `,
  ],
})
export class VaNestedSelectorComponent {
  @Input() maxHeight: number;
  @Input() showSelector = false;
  @Output() showSelectorChange: EventEmitter<boolean> = new EventEmitter();

  change(): void {
    this.showSelector = !this.showSelector;
    this.showSelectorChange.emit(this.showSelector);
  }

  hide(): void {
    this.showSelector = false;
    this.showSelectorChange.emit(this.showSelector);
  }
}

@Component({
  selector: 'va-nested-selector-title',
  template: `
    <ng-content></ng-content>
  `,
})
export class VaNestedSelectorTitleComponent {}

@Component({
  selector: 'va-selector-nest',
  template: `
    <ng-content select="va-nested-selector-item"></ng-content>
  `,
})
export class VaNestedSelectorNestComponent {}

@Component({
  selector: 'va-nested-selector-item',
  template: `
    <div>
      <div class="va-selector-item" (click)="showNest = !showNest">
        <div class="va-selector-arrow" *ngIf="contentNest.children.length !== 0">
          <div *ngIf="showNest && contentNest.children.length !== 0">&#x25BE;</div>
          <div *ngIf="!showNest && contentNest.children.length !== 0">&#x25B8;</div>
        </div>
        <div class="va-selector-content">
          <ng-content></ng-content>
        </div>
      </div>
      <div #contentNest [hidden]="!showNest" class="va-selector-nest">
        <ng-content select="va-selector-nest"></ng-content>
      </div>
    </div>
  `,
  styles: [
    `
      .va-selector-content {
        flex-grow: 1;
      }
    `,
    `
      .va-selector-item {
        padding: 10px;
        width: 100%;
        cursor: pointer;
        display: flex;
        box-sizing: border-box;
      }
    `,
    `
      .va-selector-item:hover {
        background: #f6f6f6;
      }
    `,
    `
      .va-selector-nest {
        border-left: 10px solid #e1edf4;
      }
    `,
    `
      .va-selector-arrow {
        width: 15px;
      }
    `,
  ],
})
export class VaNestedSelectorNestItemComponent {
  showNest = false;
} // kebab selector should be a camel

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[hide-selector]',
})
export class VaHideDirective {
  @Output() hideEvent: EventEmitter<boolean> = new EventEmitter();

  constructor(private _eref: ElementRef) {}

  @HostListener('document: click', ['$event'])
  onClick(event: any): void {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.hideEvent.emit(true);
    }
  }
}
